module.exports = __webpack_public_path__ + "img/example_kyc.5d88fe8.png";